import Vue from 'vue'
import VueRouter from 'vue-router'
import Demo from '../views/Demo'
import About from '../views/About'
import ButtonPage from '../views/ButtonPage'
import ServicePage from '../views/ServicePage'
import ServiceDetailsPage from '../views/ServiceDetailsPage'
import CounterUpPage from '../views/CounterUpPage'
import ProgressbarPage from '../views/ProgressbarPage'
import AccordionPage from '../views/AccordionPage'
import SocialSharePage from '../views/SocialSharePage'
import BlogGridPage from '../views/BlogGridPage'
import BlogGridSidebarPage from '../views/BlogGridSidebarPage'
import BlogListPage from '../views/BlogListPage'
import BlogListSidebarPage from '../views/BlogListSidebarPage'
import BlogDetailsPage from '../views/BlogDetailsPage'
import BlogCategoryPosts from '../components/blog/BlogCategoryPosts'
import TeamPage from '../views/TeamPage'
import PortfolioPage from '../views/PortfolioPage'
import PortfolioThreeColumnPage from '../views/PortfolioThreeColumnPage'
import PortfolioFullWidthPage from '../views/PortfolioFullWidthPage'
import PortfolioGridLayoutPage from '../views/PortfolioGridLayoutPage'
import PortfolioBoxLayoutPage from '../views/PortfolioBoxLayoutPage'
import PortfolioDetailsPage from '../views/PortfolioDetailsPage'
import TestimonialPage from '../views/TestimonialPage'
import TimelinePage from '../views/TimelinePage'
import TabPage from '../views/TabPage'
import PricingPage from '../views/PricingPage'
import SplitSectionPage from '../views/SplitSectionPage'
import CallToActionPage from '../views/CallToActionPage'
import VideoPage from '../views/VideoPage'
import GalleryPage from '../views/GalleryPage'
import ContactPage from '../views/ContactPage'
import BrandPage from '../views/BrandPage'
import ErrorPage from '../views/404'
import AdvanceTabPage from '../views/AdvanceTabPage'
import BrandCarouselPage from '../views/BrandCarouselPage'
import AdvancePricingPage from '../views/AdvancePricingPage'
import BusinessConsulting from '../views/home-pages/BusinessConsulting'
import BusinessConsulting2 from '../views/home-pages/BusinessConsulting2'
import Corporate from '../views/home-pages/Corporate'
import Business from '../views/home-pages/Business'
import DigitalAgency from '../views/home-pages/DigitalAgency'
import Finance from '../views/home-pages/Finance'
import Company from '../views/home-pages/Company'
import MarketAgency from '../views/home-pages/MarketAgency'
import TravelAgency from '../views/home-pages/TravelAgency'
import Consulting from '../views/home-pages/Consulting'
import SeoAgency from '../views/home-pages/SeoAgency'
import PersonalPortfolio from '../views/home-pages/PersonalPortfolio'
import EventConference from '../views/home-pages/EventConference'
import CreativePortfolio from '../views/home-pages/CreativePortfolio'
import Freelancer from '../views/home-pages/Freelancer'
import InternationalConsulting from '../views/home-pages/InternationalConsulting'
import Startup from '../views/home-pages/Startup'
import WebAgency from '../views/home-pages/WebAgency'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Demo',
        component: Demo,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/button',
        name: 'Button',
        component: ButtonPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/service',
        name: 'Service',
        component: ServicePage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/service-details',
        name: 'Service Details',
        component: ServiceDetailsPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/counter',
        name: 'Counter',
        component: CounterUpPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/progressbar',
        name: 'Progressbar',
        component: ProgressbarPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/accordion',
        name: 'Accordion',
        component: AccordionPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/social-share',
        name: 'Social share',
        component: SocialSharePage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/blog-grid',
        name: 'Blog grid',
        component: BlogGridPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/blog-grid-sidebar',
        name: 'Blog grid sidebar',
        component: BlogGridSidebarPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/blog-list',
        name: 'Blog list',
        component: BlogListPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/blog-list-sidebar',
        name: 'Blog list sidebar',
        component: BlogListSidebarPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/blog-details/:id',
        name: 'Blog details',
        component: BlogDetailsPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/category/:slug',
        name: 'Blog Category List',
        component: BlogCategoryPosts,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/team',
        name: 'Team',
        component: TeamPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/portfolio',
        name: 'Portfolio',
        component: PortfolioPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/portfolio-three-column',
        name: 'Portfolio three column',
        component: PortfolioThreeColumnPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/portfolio-full-width',
        name: 'Portfolio full width',
        component: PortfolioFullWidthPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/portfolio-grid-layout',
        name: 'Portfolio grid layout',
        component: PortfolioGridLayoutPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/portfolio-box-layout',
        name: 'Portfolio box layout',
        component: PortfolioBoxLayoutPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/portfolio-details/:id',
        name: 'Portfolio details',
        component: PortfolioDetailsPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/testimonial',
        name: 'Testimonial',
        component: TestimonialPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/timeline',
        name: 'Timeline',
        component: TimelinePage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/tab',
        name: 'Tab',
        component: TabPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/pricing',
        name: 'Pricing',
        component: PricingPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/spit-section',
        name: 'Split section',
        component: SplitSectionPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/call-to-action',
        name: 'Call to action',
        component: CallToActionPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/video',
        name: 'Video',
        component: VideoPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/gallery',
        name: 'Gallery',
        component: GalleryPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/contact',
        name: 'Contact',
        component: ContactPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/brand',
        name: 'Brand',
        component: BrandPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/error',
        name: 'Error',
        component: ErrorPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/advance-tab',
        name: 'Advance tab',
        component: AdvanceTabPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/brand-carousel',
        name: 'Brand carousel',
        component: BrandCarouselPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/advance-pricing',
        name: 'Advance pricing',
        component: AdvancePricingPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/portfolio-details',
        name: 'Portfolio details',
        component: PortfolioDetailsPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/blog-details',
        name: 'Blog details',
        component: BlogDetailsPage,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/business-consulting',
        name: 'Business Consulting',
        component: BusinessConsulting,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/business-consulting-2',
        name: 'Business Consulting 2',
        component: BusinessConsulting2,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/corporate',
        name: 'Corporate',
        component: Corporate,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/business',
        name: 'Business',
        component: Business,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/digital-agency',
        name: 'Digital Agency',
        component: DigitalAgency,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/finance',
        name: 'Finance',
        component: Finance,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/company',
        name: 'Company',
        component: Company,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/marketing-agency',
        name: 'Marketing Agency',
        component: MarketAgency,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/travel-agency',
        name: 'Travel Agency',
        component: TravelAgency,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/consulting',
        name: 'Consulting',
        component: Consulting,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/seo-agency',
        name: 'SEO Agency',
        component: SeoAgency,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/personal-portfolio',
        name: 'Personal Portfolio',
        component: PersonalPortfolio,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/event-conference',
        name: 'Event Conference',
        component: EventConference,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/creative-portfolio',
        name: 'Creative Portfolio',
        component: CreativePortfolio,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/freelancer',
        name: 'Freelancer',
        component: Freelancer,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/international-consulting',
        name: 'International Consulting',
        component: InternationalConsulting,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/startup',
        name: 'Startup',
        component: Startup,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    },
    {
        path: '/web-agency',
        name: 'Web Agency',
        component: WebAgency,
        meta: {
            title: '上海澜栗信息技术有限公司',
        },
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
    window.scrollTo(0, 0)
});

export default router
